<template>
  <swiper
    v-bind="$attrs"
    :loop="true"
    :modules="modules"
    :navigation="true"
    :slides-per-view="1"
    :space-between="150"
    :pagination="true"
    :draggable="true"
  >
    <swiper-slide v-for="(item, index) in items" class="w-[16rem] h-[12rem]">
      <NuxtLink :to="item" target="_blank" class="block" v-if="clickOpen">
        <NuxtImg
          v-if="item"
          :src="item"
          class="block mx-auto max-h-[30rem] bg-contain bg-center"
        />
      </NuxtLink>
      <template v-else>
        <NuxtImg
          v-if="item"
          :src="item"
          class="block mx-auto max-h-[30rem] bg-contain bg-center"
        />
      </template>
    </swiper-slide>
  </swiper>
</template>

<script>
// import Swiper core and required modules
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules'

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'

// Import Swiper styles
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
    clickOpen: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  setup() {
    const onSwiper = (swiper) => {}
    const onSlideChange = () => {}
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    }
  },
}
</script>
